<template>
    <div class="dvBgiBox">
        <div style="height: 30px;">
            <p style="font-size: 22px;font-weight: 600;text-align: right;color: #fff;">{{ $t('pv.title') }}</p>
        </div>


        <div style="display: flex;align-items: center;justify-content: space-around;">
            <div style="padding-bottom: 10px;">
                <div class="right02-1" style="position: relative;">
                    <!-- <dv-water-level-pond :config="config" style="width:100px;height:100px" /> -->
                    <div class="Pressure">
                        <Echart :options="option" id="Pressure" height="160px" width="160px"></Echart>
                        <div
                            style="position: absolute;bottom: 40px;left: 50%;transform: translateX(-50%);text-align: center;">
                            <p style="font-size: 20px;color: #fff;">{{ photovoltaic.irradiation }}w/㎡</p>
                        </div>
                    </div>
                </div>

                <div class="right02-2">
                    <p style="text-align: center;">{{ $t('pv.irradiation') }}</p>
                </div>
            </div>

            <div style="display: flex;flex-direction: column;">
                <div class="right02-3">
                    <div style="display: flex;align-items: center;">
                        <img src="../../assets/current.png" style="width: 25px;height: 25px;margin-right: 8px;" alt="">
                        <span>{{ $t('pv.voltage') }}</span>
                    </div>
                    <span class="txt">{{ photovoltaic.sun_vin }}v</span>
                </div>

                <div class="right02-3">
                    <div style="display: flex;align-items: center;">
                        <img src="../../assets/ADvoltage.png" style="width: 25px;height: 25px;margin-right: 8px;"
                            alt="">
                        <span>{{ $t('pv.current') }}</span>
                    </div>
                    <div>
                        <span class="txt">{{ photovoltaic.sun_cur }}</span>
                        <span class="txt" style="font-size: 18px;">A</span>
                    </div>
                </div>

                <div class="right02-3">
                    <div style="display: flex;align-items: center;">
                        <img src="../../assets/brightnessPower.png" style="width: 25px;height: 25px;margin-right: 8px;"
                            alt="">
                        <span>{{ $t('pv.power') }}</span>
                    </div>
                    <span class="txt">{{ photovoltaic.dischargePower }}w</span>
                </div>
            </div>

        </div>


    </div>
</template>

<script>
import Echart from '@/common/echart'

export default {
    components: {
        Echart,
    },
    data() {
        return {
            config: {
                data: [this.photovoltaic.irradiation],
                shape: 'round',
                formatter: `${this.photovoltaic.irradiation}w/㎡`
            },
            option: {
                series: [
                    {
                        type: 'gauge',
                        tickLength: 5,
                        max: 800,
                        splitNumber: 4, // 刻度分割段数
                        itemStyle: {
                            color: '#5470c6'
                        },
                        progress: {
                            itemStyle: {
                                color: '#5470c6'
                            },
                            show: true,
                            width: 5
                        },
                        axisLine: {
                            lineStyle: {
                                labelGap: 5,
                                width: 5,
                                color: [[1, '#63869e']]
                            }
                        },
                        axisTick: {
                            stroke: '#5470c6',
                            lineWidth: 5
                        },
                        splitLine: {
                            length: 15,
                            lineStyle: {
                                width: 2,
                                color: '#fff'
                            }
                        },
                        axisLabel: {
                            // distance: 25,
                            color: '#fff',
                            fontSize: 12
                        },

                        title: {
                            show: false
                        },
                        detail: {
                            valueAnimation: true,
                            formatter: '{value}w/m2',
                            fontSize: 1,
                            offsetCenter: [0, '50%'],
                            color: '#fff'
                        },
                        data: [
                            {
                                value: this.photovoltaic.irradiation
                            }
                        ]
                    }
                ]
            },
        };
    },
    props: {
        photovoltaic: {
            default: {}
        }
    },
    watch: {

    },
    methods: {

    }

}
</script>

<style scoped>
.txt {
    font-size: 24px;
    font-weight: 600;
}

.dvBgiBox {
    width: 100%;
    height: 300px;
    padding: 5px 10px 10px 10px;
    background-image: url("../../assets/dvBgiBoxRight.png");
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-bottom: 20px;
}

.right02-1 {
    width: 160px;
    height: 200px;
    background-image: url("../../assets/right02-1.png");
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
}

.Pressure {
    transition: all 0.3s ease;
}

.Pressure:hover {
    transform: scale(1.2);
    /* box-shadow: 0 0 15px rgba(59, 130, 246, 0.6); */
}

.right02-2 {
    width: 160px;
    height: 20px;
    background-image: url("../../assets/right02-2.png");
    background-size: 100% 100%;
}

.right02-3 {
    width: 250px;
    /* height: 40px; */
    margin-bottom: 25px;
    background-image: url("../../assets/right02-3.png");
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    padding: 8px 20px;
    justify-content: space-between;
}
</style>